module.exports = __webpack_public_path__ + "static/media/linkedin-white.63b51e05.svg";